var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgScetch = function SvgScetch(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.164 7.185 24 6l11.836 1.185L45 18.837 24 42 3 18.837l9.164-11.652Z",
    fill: "#FDB300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.506 18.837 24 42 3 18.837h8.506Zm24.988 0L24 42l21-23.163",
    fill: "#EA6C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.506 18.837h24.988L24 42",
    fill: "#FDAD00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6 12.163 7.185l-.657 11.652L24 6Zm0 0 11.836 1.185.658 11.652",
    fill: "#FDD231"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 18.837 35.837 7.185l.657 11.652H45Zm-42 0 9.164-11.652-.658 11.652",
    fill: "#FDAD00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 6 11.506 18.837h24.988",
    fill: "#FEEEB7"
  })));
};

export default SvgScetch;